import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Button,
  Loader,
  Icon,
  Modal
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import { clockActions } from '../../actions/clock.actions';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import { PaginationContainer } from '../../components/PaginationContainer';
import _ from 'lodash';
import { DateTimeInput } from 'semantic-ui-calendar-react-17';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class ClockIndexScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
        page: 1,
        username: null,
        period: '',
        request: {
          username: '',
          date: ''
        },
    };
  }

  static get propTypes() {
    return {
       registers: PropTypes.any,
       loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    this.handleSearchDebounced = _.debounce(function() {
      this.fetchRegisters();
    }, 500);
    const today = moment().format(DATE_FORMAT);
    this.setState({ period: `${today} - ${today}`}, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
      this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period }, () => this.fetchRegisters());
  }

  handleUsernameChange(username) {
    this.setState({ username, page: 1 });
    this.handleSearchDebounced();
  }

  reprocess(id) {
    const { dispatch } = this.props;
    dispatch(clockActions.reprocess(id)).then(() => this.fetchRegisters());
  }

  fetchRegisters(isExport) {
    const { dispatch } = this.props;
    const { page, username, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(clockActions.fetch({ page, username, startDate, endDate, orderBy: "Id", export: isExport ? true : null, ascending: false }));
  }

  handleChange(field, data) {    
    const { request } = this.state;    
    request[field] = data;    
    this.setState({ request });    
  }

  handleSubmit() {
    const { dispatch } = this.props;
    const { request } = this.state;
    let payload = {
      username: request.username,
      date: moment(request.date, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss'),
    };

    dispatch(clockActions.create(payload)).then(() => {
      this.fetchRegisters()
    });    
  }

  exportXlsx() {
    this.fetchRegisters(true).then(() => this.fetchRegisters());
  }

  render() {
    const { registers, loading, me } = this.props;
    const { period, request } = this.state;
    
    // Check Permission
    if (me && me.permissions && !me.permissions.includes("clock.fetch")) {
      window.location.href = "/";
      return;
    }

    return (
      <Fragment>
        <Header>
          <h1>Eventos de Jornada</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Data Recebido'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Username' onChange={(e, data) => this.handleUsernameChange(data.value)} loading={loading} />
            
            <Form.Button onClick={() => this.exportXlsx()} label='&nbsp;'>
              <Icon name='file excel' /> Exportar
            </Form.Button>
            <Modal trigger={<Form.Button label='&nbsp;'><Icon name='clock' /> Registrar</Form.Button>}>
              <Modal.Header>Registro Manual de Ponto</Modal.Header>
              <Modal.Content image>                      
                <Modal.Description>      
                  <Form>    
                    <Form.Input label='Username' name='username' type='text' onChange={(e, data) => this.handleChange("username", data.value)} />        
                    <Form.Field required>
                      <label>Data do Ponto</label>
                      <DateTimeInput
                        localization="pt-br"
                        name="date"
                        value={request.date}
                        closable
                        clearable
                        placeholder="Data e hora do registro"                                                
                        dateTimeFormat="DD/MM/YYYY HH:mm"
                        iconPosition="left"
                        onChange={(e, data) => this.handleChange("date", data.value)}
                      />
                    </Form.Field>                            
                    <Button primary type='submit' loading={loading} onClick={() => this.handleSubmit()}>Registrar</Button>                          
                  </Form>
                </Modal.Description>
              </Modal.Content>
            </Modal>                         
          </Form.Group>
        </Form>

        {registers && registers.Results && registers.Results.length > 0 &&
          <Table compact>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>Data Recebido</Table.HeaderCell>
                    <Table.HeaderCell>Data Registro</Table.HeaderCell>
                    <Table.HeaderCell>Sequência</Table.HeaderCell>
                    <Table.HeaderCell>Identificador</Table.HeaderCell>
                    <Table.HeaderCell>Username</Table.HeaderCell>
                    <Table.HeaderCell>Mensagem</Table.HeaderCell>
                    <Table.HeaderCell>Notificação</Table.HeaderCell>
                    <Table.HeaderCell>&nbsp;</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>              
                { registers && registers.Results && registers.Results.map((register) => {
                    return <Table.Row key={register.Id}>
                        <Table.Cell>{moment(register.CreatedAt).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
                        <Table.Cell>{moment(register.Date).format('DD/MM/YYYY HH:mm:ss')}</Table.Cell>
                        <Table.Cell>{register.Sequence}</Table.Cell>
                        <Table.Cell>{register.Identifier}</Table.Cell>
                        <Table.Cell>{register.User.Username}</Table.Cell>
                        <Table.Cell>{register.Log}</Table.Cell>
                        <Table.Cell>{register.Notification ? `${moment(register.Notification.EventTime).format('HH:mm')} - ${register.Notification.EventTypeLabel}` : '-' }</Table.Cell>
                        <Table.Cell>
                          <Button onClick={() => this.reprocess(register.Id)}>
                            <Icon name='refresh' />
                          </Button>
                        </Table.Cell>
                    </Table.Row>;
                }) }
            </Table.Body>
        </Table>}
        <PaginationContainer registers={registers} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { clock } = state;
  return {
    registers: clock || null,
    loading: clock.loading
  };
}

const connectedClockIndexScreen = connect(mapStateToProps)(ClockIndexScreen);
export { connectedClockIndexScreen as ClockIndexScreen };
